/*
 * Средства для работы с полями формы
 * Утилиты валидации, форматирования и масок.
 * Без зависимостей от Alpine.js и UI.
 *
 * Основной функционал: возвращает объект FIELD_SCHEMAS с правилами для типовых полей
 * */

; window.FFK = (() => {
	"use strict";

	if (!window.PARAMS) {
		console.error('[FFK] PARAMS.js не загружен до FormFieldKit.js');
	}
	if (!window.ValidationResult) {
		console.error('[FFK] ValidationResult.js не загружен до FormFieldKit.js');
	}

	// ═══════════════════════════════════════════════════════════════════════════
	// ФОРМАТТЕРЫ
	// ═══════════════════════════════════════════════════════════════════════════
	const Formatter = {
		// базовое для всего
		baseFormat: (value) => {
			if (value === "" || value === undefined || value === null) {
				return '';
			}

			value = String(value);
			value = value.trimStart();

			return value;
		},
		// базовое для строк
		baseWordFormat: (value) => {
			value = Formatter.baseFormat(value);
			if (!value) {
				return '';
			}

			// Удаляем латинские буквы
			//value = value.replace(/[a-zA-Z]/g, '');

			// убираем дублирование
			value = value.replace(/\){2,}/g, ')');  // убираем двойную левую скобку
			value = value.replace(/\({2,}/g, '(');  // убираем двойную правую скобку
			value = value.replace(/\'{2,}/g, '\'');  // убираем двойной апостро
			value = value.replace(/\.{2,}/g, '.');  // убираем двойную точку
			value = value.replace(/\s{2,}/g, ' ');  // убирает двойной пробел
			value = value.replace(/\-{2,}/g, '-');  // убирает двойной дефис

			// убираем лишние пробелы
			value = value.trimStart(); // убирает пробел в самом начале
			value = value.replace(/\-\s+/g, '-');  // убирает пробел после дефиса2

			return value;
		},

		digitsOnly: (value) => {
			value = Formatter.baseFormat(value) || "";
			if (!value) {
				return '';
			}

			return value.replace(/\D/g, '');
		},
		fio: (value) => {
			// https://www.consultant.ru/document/cons_doc_LAW_410788/763145d8bce1267a0501117c28ebd122104c1b8e/

			value = Formatter.baseWordFormat(value);
			if (!value) {
				return '';
			}

			// разрешенные символы
			value = value.replace(/[^а-яА-ЯёЁ\-\s\.ivIV\'\,\(\)]/g, '');

			// Cлово состоит только из римских цифр (поддерживаем базовый набор)
			const isRomanNumeral = (word) => /^[IV]+$/i.test(word);

			// каждое слово с заглавной буквы
			const words = value.split(' ');
			const formatted = words
				.map((word, idx) => {
					// Пропускаем слова, начинающиеся с дефиса
					if (word[0] === '-')
						return '';

					// Если это римская цифра — оставляем заглавной
					if (isRomanNumeral(word)) {
						return word.toUpperCase();
					}

					return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
				});
			//.filter(w => w); // убираем пустые

			return formatted.join(' ');
		},
		day: (day) => Math.min(31, Math.max(1, Number(day))),
		month: (month) => Math.min(12, Math.max(1, Number(month))),
		year: (year) => Math.min(2100, Math.max(1900, Number(year))),

		/*
		 * Заглавная первая буква у каждого слова
		 */
		address: (value) => {
			value = Formatter.baseWordFormat(value);
			if (!value) {
				return '';
			}


			// value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
			return value;
		},

		orgName: (value) => {
			value = Formatter.baseWordFormat(value);
			if (!value) {
				return '';
			}

			// Разрешаем: кириллицу, латинские римские цифры (IVXLCDM), цифры, дефис, пробелы, точки, кавычки, скобки
			value = value.replace(/[^а-яА-ЯёЁ\s\-\.\'\"\(\)\»\«\№\+,NIVXLCDM0-9]/g, '');

			// Каждое слово с заглавной
			//value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
			return value;
		},

		bik: (value) => {
			value = Formatter.baseWordFormat(value);
			value = Formatter.digitsOnly(value);
			if (!value) {
				return '';
			}


			return value;
		},

		vin: (value) => {
			value = Formatter.baseWordFormat(value);
			if (!value) {
				return '';
			}

			// Оставляем только разрешённые символы: a-h, j-n, p-r, z (регистронезависимо) и 0-9
			// Исключаем i, o, q (и их заглавные варианты), так как они визуально похожи на 1 и 0
			value = value.replace(/[^a-hj-npr-zA-HJ-NPR-Z0-9]/g, '');

			value = value.toUpperCase();

			return value;
		},

		date: (value) => {

			value = Formatter.baseFormat(value);
			if (!value) {
				return '';
			}


			// Убираем время, если есть (всё после пробела), чтобы не мешало парсингу
			const datePart = value.split(/[ T]/)[0];

			// === 1. Парсинг стандартных форматов ===

			// JS Date.toString() формат: "Fri May 08 2026 ..."
			if (/^[A-Z][a-z]{2}\s[A-Z][a-z]{2}\s\d{2}\s\d{4}/.test(value)) {
				const date = new Date(value);
				if (!isNaN(date.getTime())) {
					const d = String(date.getDate()).padStart(2, '0');
					const m = String(date.getMonth() + 1).padStart(2, '0');
					const y = date.getFullYear();
					return `${d}.${m}.${y}`;
				} else {
					console.error("Дату невозможно отформатировать!");
					return "";
				}
			}


			// ISO: YYYY-MM-DD
			if (/^\d{4}-\d{1,2}-\d{1,2}/.test(datePart)) {
				const [year, month, day] = datePart.split('-');

				const d = Formatter.day(day);
				const m = Formatter.month(month);
				const y = Formatter.year(year);
				return `${String(d).padStart(2, '0')}.${String(m).padStart(2, '0')}.${y}`;
			}

			// Европейский: DD.MM.YYYY или DD-MM-YYYY
			if (/^\d{1,2}[.-]\d{1,2}[.-]\d{4}/.test(datePart)) {
				const separator = datePart.includes('.') ? '.' : '-';
				const [day, month, year] = datePart.split(separator);

				const d = Formatter.day(day);
				const m = Formatter.month(month);
				const y = Formatter.year(year);
				return `${String(d).padStart(2, '0')}.${String(m).padStart(2, '0')}.${y}`;
			}

			// === 2. Пошаговый ввод цифрами ===

			// Чистые цифры (например, 17122020, 01012023) или нестандартный ввод
			// Предполагаем формат DDMMYYYY
			let digits = value.replace(/\D/g, '').slice(0, 8);
			let formatted = "";

			// День (1-2 цифры)
			if (digits.length >= 1) {
				const dayRaw = digits.slice(0, Math.min(2, digits.length));
				if (dayRaw.length === 2) {
					formatted += String(Formatter.day(dayRaw));
				} else {
					formatted += dayRaw; // частичный ввод — как есть
				}
			}
			// Точка после дня, если ввели хотя бы 2 цифры
			if (digits.length >= 2) {
				formatted += '.';
			}
			// Месяц (3-4 цифры)
			if (digits.length >= 3) {
				const monthRaw = digits.slice(2, Math.min(4, digits.length));
				if (monthRaw.length === 2) {
					formatted += String(Formatter.month(monthRaw));
				} else {
					formatted += monthRaw; // частичный ввод — как есть
				}
			}
			// Точка после месяца, если ввели хотя бы 4 цифры
			if (digits.length >= 4) {
				formatted += '.';
			}
			// Год (5-8 цифры)
			if (digits.length >= 5) {
				const yearRaw = digits.slice(4, 8);
				if (yearRaw.length === 4) {
					formatted += String(Formatter.year(yearRaw));
				} else {
					formatted += yearRaw; // частичный ввод — как есть
				}
			}
			return formatted;
		},
		minutes: (value) => {
			value = Formatter.baseFormat(value);
			value = Formatter.digitsOnly(value);
			if (!value)
				return "";

			const num = Number(value);
			if (isNaN(num)) {
				return "00";
			}

			if (num < 0 || num > 59) {
				return "00";
			}
			return value;
		},
		hours: (value) => {
			value = Formatter.baseFormat(value);
			value = Formatter.digitsOnly(value);
			if (!value)
				return "";

			const num = Number(value);
			if (isNaN(num)) {
				return "00";
			}

			if (num < 0 || num > 23) {
				return "00";
			}
			return value;
		},

		/**
		 * +7 (___) ___-__-__
		 */
		phone: (value) => {
			value = Formatter.baseFormat(value);
			if (!value)
				return '';

			// Очищаем от всего кроме цифр
			let digits = value.replace(/\D/g, '');

			// 8 на +7
			if (digits.startsWith('8')) {
				digits = '7' + digits.slice(1);
			}

			let formatted = '+7';
			if (digits.length > 1) {
				formatted += ' (' + digits.slice(1, 4);
			}
			if (digits.length > 4) {
				formatted += ') ' + digits.slice(4, 7);
			}
			if (digits.length > 7) {
				formatted += '-' + digits.slice(7, 9);
			}
			if (digits.length > 9) {
				formatted += '-' + digits.slice(9, 11);
			}

			return formatted;
		},

		/**
		 * Форматтер цены:
		 * - разделяет тысячи пробелами (1 500 000)
		 * - заменяет точку на запятую для копеек
		 * - всегда показывает 2 знака после запятой (добавляет 00 если нет)
		 */
		price: (value) => {
			// Пустые значения
			if (value === "" || value === undefined || value === null) {
				return '';
			}

			// Приводим к строке и убираем пробелы (если цена уже отформатирована)
			value = String(value).trim().replace(PARAMS.re.WHITESPACE_GLOBAL, '');

			// Разделяем целую и дробную часть по запятой или точке
			const parts = value.split(/[,.]/);
			let integerPart = parts[0].replace(/\D/g, ''); // только цифры
			let decimalPart = parts[1] ? parts[1].slice(0, 2).replace(/\D/g, '') : "00";

			// Нормализация дробной части: всегда 2 знака
			if (decimalPart.length === 0) {
				decimalPart = "00";
			} else if (decimalPart.length === 1) {
				decimalPart += "0";
			}

			// Если целая часть пустая — ставим 0
			if (!integerPart) {
				integerPart = "0";
			}

			// Добавляем пробелы как разделитель тысяч (русский формат)
			const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

			// Возвращаем в формате: 1 500 000,00
			return `${formattedInteger},${decimalPart}`;
		},
	};

	// форматирование перед отправкой на сервер
	const BackendFormatter = {
		date: (value) => {
			let val = value;

			if (value.endsWith(".")) {
				val = value.slice(0, -1);
			}

			return val;
		},
		number: (value) => {
			let val = value;

			if (typeof value === 'number') {
				val = String(value);
			}

			val = val.replaceAll(",", ".").replaceAll(" ", "").trim();
			return val; // возвращаем именно строку, потому что пустая строка будет возвращать 0!

			//			const number = Number(val);
			//
			//			if(Number.isNaN(number)) {
			//				PARAMS.isStage && console.error("этот форматер только для цельных чисел а пришел nan", value);
			//				return val;
			//			} else {
			//				return number
			//			}
		},
	}

	// ═══════════════════════════════════════════════════════════════════════════
	// ВАЛИДАТОРЫ
	// ═══════════════════════════════════════════════════════════════════════════
	/**
	 * Обёртка валидатора. Чтобы убрать бойлерплейт:
	 *  1. чистит null/undefined → ''
	 *  2. делает notEmpty
	 *  3. делает String(value) и передаёт строку в тело
	 *  4. приводит ответ тела к ValidationResult
	 */

	const _defineValidator = (fn, options = {}) => {
		const { required = true } = options;

		return function validated(value, ctx) {
			// 1. проверка на пустоту истичнного значения
			if (required) {
				const nonEmpty = Validator.notEmpty(value);
				if (!nonEmpty.isValid) {
					return nonEmpty;
				}
			}

			// 2. единая нормализация входа
			const v = (value === null || value === undefined) ? '' : String(value);

			// 3. тело валидатора
			let raw;
			try {
				raw = fn(v, ctx);
			} catch (e) {
				console.error('[FFK] Валидатор упал:', e);
				return ValidationResult.invalid('Некорректное значение');
			}

			// 4. единая нормализация ответа
			if (raw instanceof ValidationResult) {
				return raw;
			}
			return (raw == null) ? ValidationResult.valid() : ValidationResult.from(raw);
		};
	}

	const Validator = {
		// Простая валидация непустого значения
		notEmpty(value) {
			let isValid = true;

			// 1. Проверка на null и undefined
			if (value === null || value === undefined) {
				isValid = false;
			}
			// 2. Проверка массивов
			else if (Array.isArray(value)) {
				isValid = value.length > 0;
			}
			// 3. Проверка объектов
			else if (typeof value === 'object' && value.constructor === Object) {
				isValid = Object.keys(value).length > 0;
			}
			// 4. Проверка строк
			else if (typeof value === 'string') {
				const trimmed = value.trim();
				isValid = trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined';
			}
			// 5. С числами и булевыми значениями ничего не делаем.

			return isValid
				? ValidationResult.valid()
				: ValidationResult.invalid('Заполните поле', 1);
		},

		inn: (value, ctx) => {
			value = String(value);

			const isUr = ctx?.isUr ?? false;
			const isFiz = ctx?.isFiz ?? false;
			const isIp = ctx?.isIp ?? false;
			const isUnknownType = !isUr && !isFiz && !isIp;

			let requiredLen = [10, 12]; // если не указан тип то проверка и для фл и для юл
			if (isUr && !isFiz && !isIp) {
				requiredLen = [10];
			} else if ((isFiz || isIp) && !isUr) {
				requiredLen = [12];
			}

			if (!value.length) {
				return ValidationResult.invalid('ИНН пуст', 1);
			}
			if (PARAMS.re.NON_DIGITS.test(value)) {
				return ValidationResult.invalid('ИНН может состоять только из цифр', 2);
			}
			if (requiredLen.indexOf(value.length) === -1) {
				return ValidationResult.invalid(`ИНН может состоять только из ${requiredLen.length > 1 ? '10 или 12' : requiredLen[0]} цифр`, 3);
			}
			if (value === '0000000000' || value === '000000000000') {
				return ValidationResult.invalid('ИНН не может состоять из нулей', 4);
			}

			var checkDigit = function (inn, coefficients) {
				var n = 0;
				for (var i in coefficients) {
					n += coefficients[i] * inn[i];
				}
				return parseInt(n % 11 % 10);
			};

			var isValid = false;
			switch (value.length) {
				case 10:
					if (isUr || isUnknownType) {
						var n10 = checkDigit(value, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
						if (n10 === parseInt(value[9])) {
							isValid = true;
						}
					}

					break;
				case 12:
					if (isFiz || isIp || isUnknownType) {
						var n11 = checkDigit(value, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
						var n12 = checkDigit(value, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
						if ((n11 === parseInt(value[10])) && (n12 === parseInt(value[11]))) {
							isValid = true;
						}
					}

					break;
			}
			if (!isValid) {
				return ValidationResult.invalid('Некорректный ИНН', 4);
			}
			return ValidationResult.valid();
		},
		kpp: (value) => {
			value = String(value);

			if (!value.length) {
				return ValidationResult.invalid('КПП пуст', 1);
			}
			if (value.length !== 9) {
				return ValidationResult.invalid('КПП может состоять только из 9 знаков (цифр или заглавных букв латинского алфавита от A до Z)', 2);
			}
			if (!/^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(value)) {
				return ValidationResult.invalid('Неправильный формат КПП', 3);
			}
			return ValidationResult.valid();
		},

		year: (value) => {
			if (YearUtils.isValid(value)) {
				return ValidationResult.valid();
			}
			return ValidationResult.invalid(`Год должен быть от ${YearUtils.MIN} до ${YearUtils.MAX}`, 1);
		},
		efrsb_id: (value) => {
			value = String(value);

			if (!/^[0-9]{7,8}$/.test(value)) {
				return ValidationResult.invalid('Идентификационный номер торгов на ЕФРСБ должен состоять из 7 или 8 цифр!');
			}
			return ValidationResult.valid();
		},
		ogrn: (value) => {
			value = String(value);

			if (!value.length) {
				return ValidationResult.invalid('ОГРН пуст', 1);
			}
			if (PARAMS.re.NON_DIGITS.test(value)) {
				return ValidationResult.invalid('ОГРН может состоять только из цифр', 2);
			}
			if (value.length !== 13) {
				return ValidationResult.invalid('ОГРН может состоять только из 13 цифр', 3);
			}
			if (value === '0000000000' || value === '000000000000') {
				return ValidationResult.invalid('ОГРН не может состоять из нулей', 4);
			}

			var n13 = parseInt((parseInt(value.slice(0, -1)) % 11).toString().slice(-1));
			if (n13 === parseInt(value[12])) {
				return ValidationResult.valid();
			}
			return ValidationResult.invalid('Некорректный ОГРН', 4);
		},
		ogrnip: (value) => {
			value = String(value);

			if (!value.length) {
				return ValidationResult.invalid('ОГРНИП пуст', 1);
			}
			if (PARAMS.re.NON_DIGITS.test(value)) {
				return ValidationResult.invalid('ОГРНИП может состоять только из цифр', 2);
			}
			if (value.length !== 15) {
				return ValidationResult.invalid('ОГРНИП может состоять только из 15 цифр', 3);
			}
			if (value === '0000000000' || value === '000000000000') {
				return ValidationResult.invalid('ОГРНИП не может состоять из нулей', 4);
			}

			var n15 = parseInt((parseInt(value.slice(0, -1)) % 13).toString().slice(-1));
			if (n15 === parseInt(value[14])) {
				return ValidationResult.valid();
			}
			return ValidationResult.invalid('Некорректный ОГРНИП', 4);
		},

		snils: (value) => {
			value = String(value);
			value = value.replace(/[\-\ ]/g, "");
			if (!value.length) {
				return ValidationResult.invalid('СНИЛС пуст', 1);
			}
			if (PARAMS.re.NON_DIGITS.test(value)) {
				return ValidationResult.invalid('СНИЛС может состоять только из цифр', 2);
			}
			if (value.length !== 11) {
				return ValidationResult.invalid('СНИЛС может состоять только из 11 цифр', 3);
			}

			//Проверка контрольного числа Страхового номера проводится только для номеров больше номера 001-001-998
			if (value <= 100199800) {
				return ValidationResult.valid();
			}
			var sum = 0;
			for (var i = 0; i < 9; i++) {
				sum += parseInt(value[i]) * (9 - i);
			}
			var checkDigit = 0;
			if (sum < 100) {
				checkDigit = sum;
			} else if (sum > 101) {
				checkDigit = parseInt(sum % 101);
				if (checkDigit === 100) {
					checkDigit = 0;
				}
			}
			if (checkDigit === parseInt(value.slice(-2))) {
				return ValidationResult.valid();
			}
			return ValidationResult.invalid('Неправильный СНИЛС', 4);
		},
		rs: (rs, bik) => {
			rs = String(rs);
			bik = String(bik);

			rs = rs.replace(/[\-\ ]/g, "");
			bik = bik.replace(/[\ ]/g, "");
			if (!rs.length) {
				return ValidationResult.invalid('Счет пуст', 1);
			}
			if (PARAMS.re.NON_DIGITS.test(rs)) {
				return ValidationResult.invalid('Счет может состоять только из цифр', 2);
			}
			if (rs.length !== 20) {
				return ValidationResult.invalid('Счет может состоять только из 20 цифр', 3);
			}

			if (rs.substr(0, 2) === "03") {
				//казначейский??
				return ValidationResult.valid();
			}

			var bikRs;
			if (bik.substring(6, 8) === "00") {
				bikRs = "0" + bik.substring(4, 6) + rs;
			} else {
				bikRs = bik.toString().slice(-3) + rs;
			}
			var checksum = 0;
			var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
			for (var i in coefficients) {
				checksum += coefficients[i] * (bikRs[i] % 10);
			}
			if (checksum % 10 === 0) {
				return ValidationResult.valid();
			}
			return ValidationResult.invalid('Неверно указан расчетный счет или БИК', 4);
		},
		rsOwner: _defineValidator((rs, name) => {
			const d = Formatter.digitsOnly(rs);
			const n = String(name ?? "").trim().toLowerCase();
			const hasIpPrefix = n.startsWith("ип ") || n.startsWith("индивидуальный");
			if (d.startsWith("40802") && !hasIpPrefix) {
				return ValidationResult.invalid("В наименовании получателя должно быть указано ИП, так как счет принадлежит ИП.", 2);
			}
			if (!d.startsWith("40802") && hasIpPrefix) {
				if (d.length < 5) {
					return ValidationResult.valid();
				}
				return ValidationResult.invalid(d.startsWith("40817")
					? "Счет принадлежит физическому лицу, уберите ИП из наименования получателя"
					: "Счет принадлежит юридическому лицу, уберите ИП из наименования получателя");
			}
			return ValidationResult.valid();
		}),

		bik: (value) => {
			return ValidationResult.valid();
		},

		/**
		 * Проверка ФИО (checkFIOpartNew в java)
		 * В соответствии с приказом ФНС:  https://www.consultant.ru/document/cons_doc_LAW_410788/763145d8bce1267a0501117c28ebd122104c1b8e/
		 * @param s - строка
		 * @return boolean
		 */
		fio: _defineValidator((value) => {
			// Предварительные проверки
			if (
				value.endsWith(" .")
				|| // заканчивается пробел+точка
				value.endsWith("(")
				|| // заканчивается открывающей скобкой
				value.includes("  ")
				|| // два пробела подряд
				value.includes("--")
				|| // два дефиса подряд
				value.includes("''")
				|| // два апострофа подряд
				value.includes(" .")
				|| // пробел перед точкой
				value.includes("- ")
				|| // пробел после дефиса
				value.includes(" -")
			) {
				return ValidationResult.invalid('Некорректное ФИО', 2);
			}

			// Основная проверка

			const russianLetters = "А-ЯЁа-яё";
			const romanNumerals = "IV";

			const pattern = "^[" + russianLetters + "]+"
				+ "("
				+ // Пробел + НЕ пробел
				"\\s[" + russianLetters + romanNumerals + "\\(\\)\\.]+" +
				"|" +
				// Дефис + НЕ дефис
				"\-[" + russianLetters + romanNumerals + "\\(\\)\\s\\.]+" +
				"|" +
				// Апостроф + НЕ апостроф
				"\'[" + russianLetters + romanNumerals + "\\(\\)\\s\\.]+" +
				"|" +
				// Запятая + пробел + буквы (запятая всегда с пробелом)
				"\\,\\s[" + russianLetters + romanNumerals + "\\(\\)\\.]+" +
				"|" +
				// Скобки и точки + любые разрешенные символы
				"[\\(\\)\\.][" + russianLetters + romanNumerals + "\\(\\)\\s\\.]+" +
				")*$";

			if (!new RegExp(pattern).test(value)) {
				return ValidationResult.invalid('Некорректное ФИО', 3);
			}

			return ValidationResult.valid();
		}),
		/**
		 * Валидация почтового индекса
		 * @param {String} value
		 * @param {String} error
		 * @returns {undefined}
		 */
		postal_index: (value) => {
			value = String(value);

			if (!value.length) {
				return ValidationResult.invalid('Почтовый индекс пуст', 1);
			}
			if (PARAMS.re.NON_DIGITS.test(value)) {
				return ValidationResult.invalid('Почтовый индекс может состоять только из цифр', 2);
			}
			if (value.length < 4 || value.length > 9) { // индексы из других стран разной длины
				return ValidationResult.invalid('Некорректный почтовый индекс', 3);
			}
			return ValidationResult.valid();
		},
		/**
		 * Валидация адреса
		 * не менее 3х слов
		 * на бэке auth.hasValidAddr
		 * @param {String} address
		 * @returns {undefined}
		 */
		address: (value) => {
			value = String(value);

			value = value.split(" ");
			if (value.length < 3) {
				return ValidationResult.invalid('Некорректный почтовый адрес');
			}
			return ValidationResult.valid();
		},
		// есть форматирование, но валидацию оставил на всякий случай
		phone: (value) => {
			value = String(value);

			if (value.replace(PARAMS.re.NON_DIGIT_DOT_G, '').length < 11 || value.replace(PARAMS.re.NON_DIGIT_DOT_G, '').length > 11) {
				return ValidationResult.invalid('Некорректный номер телефона');
			}
			return ValidationResult.valid();
		},
		email: (value) => {
			value = String(value);

			var re = PARAMS.re.EMAIL_VALIDATION;
			if (!re.test(value.toLowerCase())) {
				return ValidationResult.invalid('Некорректная почта');
			}
			return ValidationResult.valid();
		},
		full_name: (value) => {
			return Validator.notEmpty(value);
		},
		short_name: (value) => {
			return Validator.notEmpty(value);
		},
		bank_name: (value) => {
			return Validator.notEmpty(value);
		},
		recipient_name: (value) => {
			return Validator.notEmpty(value);
		},
		phone: (value) => {
			value = String(value);

			if (value.replace(PARAMS.re.NON_DIGIT_DOT_G, '').length < 11 || value.replace(PARAMS.re.NON_DIGIT_DOT_G, '').length > 11) {
				return ValidationResult.invalid('Некорректный номер телефона');
			}
			return ValidationResult.valid();
		},

		date: (value) => {
			value = String(value);

			if (value.length === 0) {
				return ValidationResult.invalid("Заполните дату!");
			}

			var separators = ['\\.'];
			var bits = value.split(new RegExp(separators.join('|'), 'g'));
			var d = new Date(bits[2], bits[1] - 1, bits[0]);
			var ret = bits.length == 3 && d.getFullYear() == bits[2] && d.getMonth() + 1 == bits[1];
			if (!ret) {
				return ValidationResult.invalid("Неверный формат даты!");
			}
			return ValidationResult.valid();
		},

		birth_date: (value) => {
			const formatCheck = Validator.date(value);
			if (formatCheck.hasError()) {
				return ValidationResult.invalid('Некорректная дата рождения', 1);
			}
			if (!DateUtils.isAdult(value)) {
				return ValidationResult.invalid('Некорректная дата рождения', 2);
			}
			return ValidationResult.valid();
		},
		issued_date: (value) => {
			const formatCheck = Validator.date(value);
			if (formatCheck.hasError()) {
				return ValidationResult.invalid('Некорректная дата выдачи документа', 1);
			}
			if (!DateUtils.isNotFutureDate(value)) {
				return ValidationResult.invalid('Некорректная дата выдачи документа', 2);
			}
			return ValidationResult.valid();
		},

		floor: (value) => {
			const clean = value.replace(PARAMS.re.WHITESPACE_GLOBAL, '');
			const num = parseInt(clean, 10);

			if (isNaN(num)) {
				return ValidationResult.invalid('Введите корректное число');
			}
			// Ограничиваем разумным диапазоном
			if (num < -2 || num > 999) {
				return ValidationResult.invalid('Допустимый диапазон: от -2 до 999');
			}
			return ValidationResult.valid();
		},

	};

	// ═══════════════════════════════════════════════════════════════════════════
	// операции с годами (сравнение, диапазон и т.д.)
	// ═══════════════════════════════════════════════════════════════════════════

	const YearUtils = {
		MIN: 1900,
		MAX: 2100,

		/**
		 * Проверка: является ли значение допустимым годом (полные 4 цифры + диапазон)
		 */
		isValid: (value) => {
			value = Formatter.digitsOnly(value);
			if (!value || value.length !== 4)
				return false;
			const year = Number(value);
			return year >= YearUtils.MIN && year <= YearUtils.MAX;
		},

		/**
		 * Возвращает доступный диапазон лет (для UI-компонентов: select, datepicker)
		 */
		getRange: () => ({ min: YearUtils.MIN, max: YearUtils.MAX }),

		/**
		 * Форматтер для ввода: не блокирует частичный ввод, но ограничивает финальное значение
		 */
		format: (value) => {
			value = Formatter.baseFormat(value);
			value = Formatter.digitsOnly(value);
			if (!value)
				return '';

			// Если пользователь ещё печатает (1-3 цифры) — не применяем clamp
			if (value.length < 4) {
				return value;
			}

			// Полное значение — ограничиваем диапазоном
			const year = Number(value);
			return String(Math.min(YearUtils.MAX, Math.max(YearUtils.MIN, year)));
		},

		/**
		 * Строгая нормализация: всегда возвращает год в диапазоне или пустую строку
		 * Используется при сохранении/отправке данных
		 */
		normalize: (value) => {
			value = Formatter.digitsOnly(value);
			if (!value)
				return '';
			const year = Number(value);
			if (year < YearUtils.MIN || year > YearUtils.MAX)
				return '';
			return String(year);
		}
	};


	// ═══════════════════════════════════════════════════════════════════════════
	// операции с датами (сравнение, диапазон и т.д.)
	// ═══════════════════════════════════════════════════════════════════════════
	const DateUtils = {
		/**
		 * Парсит строку "ДД.ММ.ГГГГ" в объект Date
		 * @param {string} dateStr - дата в формате DD.MM.YYYY
		 * @returns {Date|null}
		 */
		toDate: (dateStr) => {
			if (!dateStr) {
				return null;
			}

			const parts = String(dateStr).trim().split('.');
			if (parts.length !== 3) {
				return null;
			}

			const [day, month, year] = parts.map(Number);
			if (!day || !month || !year) {
				return null;
			}

			const date = new Date(year, month - 1, day);
			// Проверка на "перекос" даты (32.01 → 01.02)
			if (date.getDate() !== day || date.getMonth() !== month - 1) {
				return null;
			}
			return date;
		},

		/**
		 * Конвертирует дату в строку "ДД.ММ.ГГГГ"
		 * @param {Date|string|number} input - Date, timestamp или строка
		 * @returns {string}
		 */
		toDDMMYYYY: (input) => {
			const date = input instanceof Date ? input : DateUtils.toDate(input);
			if (!date || isNaN(date)) {
				return '';
			}

			const d = String(date.getDate()).padStart(2, '0');
			const m = String(date.getMonth() + 1).padStart(2, '0');
			const y = date.getFullYear();
			return `${d}.${m}.${y}`;
		},

		/**
		 * Конвертирует в формат для JSON/API: "YYYY-MM-DD"
		 * @param {string} dateStr - "ДД.ММ.ГГГГ"
		 * @returns {string|null}
		 */
		toISO: (dateStr) => {
			const date = DateUtils.toDate(dateStr);
			if (!date) {
				return null;
			}


			const d = String(date.getDate()).padStart(2, '0');
			const m = String(date.getMonth() + 1).padStart(2, '0');
			const y = date.getFullYear();
			return `${y}-${m}-${d}`;
		},

		/**
		 * Конвертирует в формат для JSON/API: "YYYY-MM-DD-T-HH-MM"
		 * @param {string} dateStr - "ДД.ММ.ГГГГ"
		 * @returns {string|null}
		 */
		toISODateTime: (dateStr, hours, minutes) => {
			const date = DateUtils.toISO(dateStr);
			if (!date) {
				return "";
			}

			return `${date}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
		},
		/**
		 * Конвертирует из ISO "YYYY-MM-DD" в "ДД.ММ.ГГГГ"
		 * @param {string} isoStr
		 * @returns {string}
		 */
		fromISO: (isoStr) => {
			if (!isoStr) {
				return '';
			}

			const [year, month, day] = isoStr.split('-');
			return `${day}.${month}.${year}`;
		},

		/**
		 * Конвертирует в timestamp (UTC midnight)
		 * @param {string} dateStr
		 * @returns {number|null}
		 */
		toTimestamp: (dateStr) => {
			const date = DateUtils.toDate(dateStr);
			if (!date) {
				return null;
			}

			return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
		},

		/**
		 * Сравнение двух дат в формате "ДД.ММ.ГГГГ"
		 * @returns {-1|0|1} -1: first < second, 0: equal, 1: first > second
		 */
		compare: (first, second) => {
			const d1 = DateUtils.toTimestamp(first);
			const d2 = DateUtils.toTimestamp(second);
			if (d1 === null || d2 === null) {
				return NaN;
			}

			return d1 === d2 ? 0 : (d1 > d2 ? 1 : -1);
		},

		/**
		 * Проверка: дата в диапазоне [min, max]
		 * @param {string} dateStr
		 * @param {string} [min]
		 * @param {string} [max]
		 * @returns {boolean}
		 */
		isInRange: (dateStr, min, max) => {
			const ts = DateUtils.toTimestamp(dateStr);
			if (ts === null) {
				return false;
			}

			if (min && ts < DateUtils.toTimestamp(min)) {
				return false;
			}

			if (max && ts > DateUtils.toTimestamp(max)) {
				return false;
			}

			return true;
		},

		/**
		 * Добавление дней к дате
		 * @param {string} dateStr
		 * @param {number} days
		 * @returns {string} новая дата в "ДД.ММ.ГГГГ"
		 */
		addDays: (dateStr, days) => {
			const date = DateUtils.toDate(dateStr);
			if (!date) {
				return '';
			}

			date.setDate(date.getDate() + days);
			return DateUtils.toDDMMYYYY(date);
		},

		/**
		 * Разница в днях между датами
		 * @returns {number|null}
		 */
		diffInDays: (first, second) => {
			const t1 = DateUtils.toTimestamp(first);
			const t2 = DateUtils.toTimestamp(second);
			if (t1 === null || t2 === null) {
				return null;
			}

			return Math.round((t1 - t2) / (1000 * 60 * 60 * 24));
		},

		/**
		 * Извлекает часы из строки в формате ISO "YYYY-MM-DDTHH:MM"
		 * @param {string} isoStr
		 * @returns {number|null}
		 */
		getHours: (isoStr) => {
			if (!isoStr || typeof isoStr !== 'string') {
				return null;
			}

			const match = isoStr.match(/T(\d{2}):/);
			return match ? parseInt(match[1], 10) : null;
		},

		/**
		 * Извлекает минуты из строки в формате ISO "YYYY-MM-DDTHH:MM"
		 * @param {string} isoStr
		 * @returns {number|null}
		 */
		getMinutes: (isoStr) => {
			if (!isoStr || typeof isoStr !== 'string') {
				return null;
			}

			const match = isoStr.match(/T\d{2}:(\d{2})/);
			return match ? parseInt(match[1], 10) : null;
		},

		/**
		 * Проверяет, что дата не раньше любой из указанных
		 * @param {string} date - проверяемая дата "ДД.ММ.ГГГГ"
		 * @param {...string} minDates - список минимальных дат для сравнения
		 * @returns {boolean} true, если date >= всех minDates
		 */
		isNotEarlierThanAll: (date, ...minDates) => {
			const ts = DateUtils.toTimestamp(date);
			if (ts === null) {
				return false;
			}

			for (const min of minDates) {
				const minTs = DateUtils.toTimestamp(min);
				if (minTs !== null && ts < minTs) {
					return false;
				}
			}
			return true;
		},

		/**
		 * Возвращает дату, не раньше указанной минимальной
		 * @param {string} date - проверяемая дата "ДД.ММ.ГГГГ"
		 * @param {string} minDate - минимальная допустимая дата
		 * @returns {string} исходная дата или minDate, если date < minDate
		 */
		ensureNotEarlierThan: (date, minDate) => {
			const ts = DateUtils.toTimestamp(date);
			const minTs = DateUtils.toTimestamp(minDate);

			// Если одна из дат невалидна — возвращаем исходную
			if (ts === null || minTs === null) {
				return date;
			}


			// Если date >= minDate — возвращаем как есть
			if (ts >= minTs) {
				return date;
			}


			// Иначе возвращаем minDate
			return minDate;
		},
		/**
		 * Возвращает дату, не раньше любой из указанных минимальных дат.
		 * Игнорирует пустые или невалидные даты в массиве.
		 *
		 * @param {string} date - проверяемая дата "ДД.ММ.ГГГГ"
		 * @param {string[]} minDates - массив минимальных допустимых дат ["ДД.ММ.ГГГГ", ...]
		 * @returns {string} исходная дата или максимальная из валидных minDates, если date < неё
		 */
		ensureNotEarlierThanAll: (date, minDates = []) => {
			const ts = DateUtils.toTimestamp(date);

			// Если проверяемая дата невалидна, возвращаем её как есть
			if (ts === null) {
				return date;
			}

			let maxMinTs = null;
			let maxMinDateStr = null;

			// Проходим по массиву и ищем самую позднюю (максимальную) валидную дату
			for (const minDate of minDates) {
				const minTs = DateUtils.toTimestamp(minDate);
				if (minTs !== null) {
					if (maxMinTs === null || minTs > maxMinTs) {
						maxMinTs = minTs;
						maxMinDateStr = minDate; // запоминаем исходную строку
					}
				}
			}

			// Если в массиве не было ни одной валидной даты, возвращаем исходную
			if (maxMinTs === null) {
				return date;
			}

			// Если проверяемая дата >= самой поздней минимальной даты — всё корректно
			if (ts >= maxMinTs) {
				return date;
			}

			// Иначе сдвигаем дату до этой максимальной минимальной даты
			return maxMinDateStr;
		},

		/**
		 * Проверяет, что дата не позже сегодняшней (дата <= сегодня)
		 * @param {string} dateStr - проверяемая дата в формате "ДД.ММ.ГГГГ"
		 * @returns {boolean} true, если дата валидна и не позже сегодняшнего дня
		 */
		isNotLaterThanToday: (dateStr) => {
			const ts = DateUtils.toTimestamp(dateStr);
			if (ts === null) {
				return false;
			}

			const now = new Date();
			const todayTs = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

			return ts <= todayTs;
		},

		/**
		 * Возвращает сегодняшнюю дату в формате "ДД.ММ.ГГГГ"
		 * @returns {string}
		 */
		getToday: () => {
			const now = new Date();
			const d = String(now.getDate()).padStart(2, '0');
			const m = String(now.getMonth() + 1).padStart(2, '0');
			const y = now.getFullYear();
			return `${d}.${m}.${y}`;
		},

		/**
		* Определяет, будущая ли дата
		* @param {type} date
		* @returns {Boolean}
		*/
		isNotFutureDate(date) {
			try { // если не можем проверить или некорретная дата то false

				// Проверяем корректность даты
				if (Validator.date(date).hasError()) {
					return false;
				}

				// Парсим дату
				const datePattern = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
				const match = date.match(datePattern);

				const day = Number.parseInt(match[1], 10);
				const month = Number.parseInt(match[2], 10) - 1;// месяцы начинаются с 0
				const year = Number.parseInt(match[3], 10);

				// Создаём объект даты
				const parsedDate = new Date(year, month, day);

				// Получаем текущую дату (без времени, только день/месяц/год)
				const today = new Date();
				today.setHours(0, 0, 0, 0);

				// Сравниваем: дата не должна быть позже today (сегодняшней даты)
				return parsedDate <= today;
			} catch (e) {
				// При любой ошибке — возвращаем false
				return false;
			}
		},

		/**
		 * Получить минимальную дату рождения для совершеннолетия
		 * @returns {string} минимальная дата рождения в формате DD.MM.YYYY для совершеннолетнего человека
		 */
		getMinAdultDate() {
			const currentDate = new Date();

			// Отнимаем 18 лет от текущей даты
			const minBirthDate = new Date(currentDate);
			minBirthDate.setFullYear(minBirthDate.getFullYear() - 18);

			// Форматируем результат в DD.MM.YYYY
			const day = String(minBirthDate.getDate()).padStart(2, "0");
			const month = String(minBirthDate.getMonth() + 1).padStart(2, "0"); // +1 так как месяцы начинаются с 0
			const year = minBirthDate.getFullYear();

			return `${day}.${month}.${year}`;
		},

		/**
		 * Проверка на совершеннолетие по дате рождения
		 * @param {string} date - дата рождения в формате DD.MM.YYYY
		 * @returns {boolean} true если совершеннолетний, false если нет
		 * @throws {Error} false если дата некорректна
		 */
		isAdult(date) {
			try { // если не можем преобразовать или некорретная дата то false

				// Проверяем корректность даты
				if (Validator.date(date).hasError()) {
					throw new Error("");
				}

				// Парсим дату
				const datePattern = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
				const match = date.match(datePattern);

				const day = Number.parseInt(match[1], 10);
				const month = Number.parseInt(match[2], 10) - 1;// месяцы начинаются с 0
				const year = Number.parseInt(match[3], 10);

				// Создаем объекты дат
				const birthDateObj = new Date(year, month, day);
				const currentDate = new Date();

				// Вычисляем точный возраст
				let age = currentDate.getFullYear() - birthDateObj.getFullYear();

				// Проверяем, наступил ли день рождения в этом году
				const monthDiff = currentDate.getMonth() - birthDateObj.getMonth();
				const dayDiff = currentDate.getDate() - birthDateObj.getDate();

				// Если месяц рождения еще не наступил, или наступил но день рождения еще не прошел
				if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
					age--;
				}

				return age >= 18;

			} catch (e) {
				// При любой ошибке — возвращаем false
				//aAlert("Некорректная дата рождения");
				return false;
			}
		},
	};

	// ═══════════════════════════════════════════════════════════════════════════
	// СХЕМЫ ПОЛЕЙ
	// ═══════════════════════════════════════════════════════════════════════════
	const FIELD_SCHEMAS = {
		// === данные огранизационной формы  ===
		inn: {
			label: 'ИНН',
			placeholder: 'Введите ИНН',
			validate: Validator.inn,
			format: Formatter.digitsOnly,
			autocomplete: false,
		},
		recipient_inn: {
			label: `ИНН получателя <span style="color: red">(не банка!)`,
			placeholder: 'Введите ИНН получателя',
			validate: Validator.inn,
			format: Formatter.digitsOnly,
			autocomplete: false,
		},
		ogrn: {
			type: 'text',
			label: 'ОГРН',
			placeholder: 'Введите ОГРН',
			validate: Validator.ogrn,
			format: Formatter.digitsOnly,
			maxlength: 13,
			autocomplete: false,
		},
		ogrnip: {
			label: 'ОГРНИП',
			placeholder: 'Введите ОГРНИП',
			validate: Validator.ogrnip,
			format: Formatter.digitsOnly,
			maxlength: 15,
			autocomplete: false,
		},
		snils: {
			label: 'СНИЛС',
			placeholder: 'Введите СНИЛС',
			validate: Validator.snils,
			//format: Formatter.digitsOnly,
			mask: {
				mask: '***-***-*** **',
				tokens: {
					'*': { pattern: /[0-9]/ },
				},
				eager: true
			},
			maxlength: 14, // по факту 11, но с маской  нужно место
			autocomplete: false,
		},

		full_name: {// (только ЮР)
			label: 'Полное наименование',
			placeholder: 'Общество с ограниченной ответственностью "Ромашка"',
			validate: Validator.full_name,
			format: Formatter.orgName,
			maxlength: 500,
			autocomplete: false,
		},
		short_name: {// (только ЮР)
			label: 'Краткое наименование',
			placeholder: 'ООО "Ромашка"',
			validate: Validator.short_name,
			format: Formatter.orgName,
			maxlength: 255,
			autocomplete: false,
			required: false, // 4915 - ни одна организационно-правовая форма не обязана иметь сокращённое наименование.
		},

		address: {// адрес Юрлиц
			label: 'Адрес',
			placeholder: 'г. Москва, ул. Гагарина',
			validate: Validator.address,
			format: Formatter.address,
			maxlength: 255,
		},

		recipient_name: {
			label: 'Наименование получателя',
			placeholder: 'ООО "Ромашка"',
			validate: Validator.recipient_name,
			format: Formatter.orgName,
			maxlength: 255,
			autocomplete: false,
		},

		postal_address: {// почтовый адрес
			label: 'Почтовый адрес',
			placeholder: 'г. Москва, ул. Гагарина',
			validate: Validator.address,
			format: Formatter.address,
			maxlength: 255,
		},

		// === Реквизиты  ===
		kpp: {
			type: 'tel',
			label: 'КПП',
			placeholder: 'Укажите КПП',
			validate: Validator.kpp,
			format: Formatter.digitsOnly,
			maxlength: 9,
		},

		bank_name: {
			label: 'Банк',
			placeholder: 'Краткое наименование Банка или БИК',
			validate: Validator.bank_name,
			format: Formatter.orgName,
			maxlength: 1000,
		},

		bik: {
			label: 'БИК',
			placeholder: 'Выберите банк',

			validate: Validator.bik,
			format: Formatter.digitsOnly,
			maxlength: 9,
		},
		rs: {
			label: 'Счёт',
			placeholder: 'Заполните счёт',
			validate: (value, context) => Validator.rs(value, context?.bik),
			format: Formatter.digitsOnly,
			maxlength: 20,
			dependencies: ['bik']
		},
		ks: {
			label: 'К/С',
			placeholder: 'Выберите банк',
			//validate: (value, context) => Validator.rs(value, context?.bik),
			format: Formatter.digitsOnly,
			maxlength: 20,
			dependencies: ['bik']
		},

		// === контакты  ===
		email: {
			label: "Адрес электронной почты",
			placeholder: 'example@mail.ru',
			validate: Validator.email,
			maxlength: 320,

			/**
			 * Маскировка email
			 * @param {String} email - почта
			 * @returns {String} - *****@*****.ru
			 */
			// obfuscate(email) {
			// 	const parts = email.split("@");
			// 	if (parts.length !== 2) {
			// 		return "*****"; // Неверный формат email
			// 	}

			// 	const domainParts = parts[1].split(".");
			// 	if (domainParts.length < 2) {
			// 		return "*****@*****"; // Нет TLD
			// 	}
			// 	const tld = domainParts.pop(); // Получаем TLD (например, 'com', 'ru')
			// 	return `*****@*****.${tld}`;
			// },
		},
		phone: {
			type: 'text',
			label: 'Номер контактного телефона',
			placeholder: '+7 (___) ___-__-__',
			validate: Validator.phone,
			format: Formatter.phone,
			// Пока есть маска, форматирование не работает
			mask: {
				mask: "+7 (***) ***-**-**",
				tokens: { "*": { pattern: /[0-9]/ } },
				eager: true
			},
			/**
			 * Маскировка phone
			 * @param {String} phone - телефон
			 * @returns {String} - **********30
			 */
			// obfuscate(phone) {
			// 	return phone.slice(0, -2).replace(/./g, "*") + phone.slice(-2);
			// },
		},

		imya: {
			label: 'Имя',
			//placeholder: 'Иван',
			validate: Validator.fio,
			format: Formatter.fio,
			maxlength: 50,
			autocomplete: false,
		},

		famil: {
			label: 'Фамилия',
			//placeholder: 'Иванов',
			validate: Validator.fio,
			format: Formatter.fio,
			maxlength: 50,
			autocomplete: false,
		},
		otch: {
			label: 'Отчество',
			//placeholder: 'Иванович',
			validate: Validator.fio,
			format: Formatter.fio,
			maxlength: 50,
			autocomplete: false,
		},

		// ===  типы полей  ===
		date: {
			label: "Дата",
			placeholder: 'Укажите дату',
			validate: Validator.date,
			format: Formatter.date,
			autocomplete: false,
			//			mask: {
			//				mask: "**.**.****",
			//				tokens: {"*": {pattern: /[0-9]/}},
			//				eager: true
			//			}
		},
		mm: {
			label: "Минуты",
			placeholder: "00",
			default: "00",
			format: Formatter.minutes,
			maxlength: 2,
			autocomplete: false,
		},
		hh: {
			label: "Часы",
			placeholder: "00",
			default: "00",
			format: Formatter.hours,
			maxlength: 2,
			autocomplete: false,
		},
		year: {
			label: "Год",
			placeholder: "1900",
			format: YearUtils.format,
			validate: Validator.year,
			maxlength: 4,
			autocomplete: false,
		},

		video: {
			label: "Видео",
			placeholder: "Ссылка на видео Rutube",
			maxlength: 1000,
			autocomplete: false,
		},

		textarea: {
			//rows: 3,
			maxlength: 3000,
		},
		big_textarea: {
			//rows: 10,
			maxlength: 10000,
		},

		// === специфичные поля  ===
		efrsb_id: {
			label: 'Идентификационный номер торгов на ЕФРСБ',
			placeholder: 'Введите номер',
			maxlength: 8,
			format: Formatter.digitsOnly,
			validate: Validator.efrsb_id,
			autocomplete: false,
		},

		vin: {
			label: "Идентификационный номер (VIN)",
			placeholder: "1ZVHT84N495104650",
			format: Formatter.vin,
			maxlength: 17,
		},

		floor: {
			label: 'Этаж',
			placeholder: '00',
			maxlength: 3,
			mask: {
				mask: 'number',
				number: {
					locale: 'ru-RU',
					fraction: 0, // только целые числа
					unsigned: false   // разрешаем знак минус (по умолчанию false, но явно указываем для ясности)
				},
				eager: true
			},
			validate: Validator.floor,
			autocomplete: false,
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},

		// ==== МАСКИ ЦИФР
		// Для целых чисел без группировки
		xxx: {
			placeholder: "00",
			maxlength: 3,
			format(value) {
				value = Formatter.baseFormat(value);
				value = Formatter.digitsOnly(value);
				if (!value)
					return "";

				const num = Number(value);
				if (isNaN(num)) {
					return "1";
				}

				if (num < 1) {
					return "1";
				}
				if (num > 999) {
					return "999";
				}

				return value;
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},
		xxxx: {
			placeholder: "00",
			maxlength: 4,
			format(value) {
				value = Formatter.baseFormat(value);
				value = Formatter.digitsOnly(value);
				if (!value)
					return "";

				const num = Number(value);
				if (isNaN(num)) {
					return "1";
				}

				if (num < 1) {
					return "1";
				}
				if (num > 9999) {
					return "9999";
				}

				return value;
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},

		// Для цен и больших чисел используем группировку по маске
		xx_00: {
			placeholder: "00",
			//maxlength: 5,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 2, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					const clean = value.replace(PARAMS.re.NON_NUMERIC_DECIMAL_CHARS_G, '');
					const parts = clean.split(PARAMS.re.DECIMAL_SEPARATORS);
					let int = parts[0].slice(0, 2);
					if (parts.length > 1) {
						return int + '.' + parts[1].slice(0, 2);
					}
					return int;
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}

		},

		xxxx_00: {
			placeholder: "0000,00",
			//maxlength: 7,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 2, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					const clean = value.replace(PARAMS.re.NON_NUMERIC_DECIMAL_CHARS_G, '');
					const parts = clean.split(PARAMS.re.DECIMAL_SEPARATORS);
					let int = parts[0].slice(0, 4);
					if (parts.length > 1) {
						return int + '.' + parts[1].slice(0, 2);
					}
					return int;
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}

		},

		x_xxx_xxx: {
			placeholder: "0 000 000",
			//maxlength: 9,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 0, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					return value.replace(/[^\d]/g, '').slice(0, 7);
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},

		xxx_xxx_xxx__00: {
			placeholder: "0 000 000",
			//maxlength: 15,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 2, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					const clean = value.replace(PARAMS.re.NON_NUMERIC_DECIMAL_CHARS_G, '');
					const parts = clean.split(PARAMS.re.DECIMAL_SEPARATORS);
					let int = parts[0].slice(0, 9);
					if (parts.length > 1) {
						return int + '.' + parts[1].slice(0, 2);
					}
					return int;
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},

		xx_xxx_xxx_xxx_xxx_00: {
			placeholder: "0 000 000",
			//maxlength: 21,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 2, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					const clean = value.replace(PARAMS.re.NON_NUMERIC_DECIMAL_CHARS_G, '');
					const parts = clean.split(PARAMS.re.DECIMAL_SEPARATORS);
					let int = parts[0].slice(0, 14);
					if (parts.length > 1) {
						return int + '.' + parts[1].slice(0, 2);
					}
					return int;
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		}
	};

	// ═══════════════════════════════════════════════════════════════════════════
	// ОБРАБОТЧИКИ СОБЫТИЙ
	// ═══════════════════════════════════════════════════════════════════════════

	// внутренние методы-хелперы для funcForHandlers
	const eventsFuncsHelpers = {
		/**
		 * Удаляет пробелы, табуляцию, переносы строк и невидимые служебные символы.
		 *
		 * @param {string} value - исходное значение
		 * @param {'remove'|'trim'} [mode='remove']
		 *        remove — удалить все такие символы по всей строке
		 *        trim   — убрать только в начале и в конце строки
		 * @returns {string}
		 */
		cleanInvisible(value, mode = 'remove') {
			const str = String(value ?? '');

			if (mode === 'trim') {
				return str.replace(PARAMS.re.INVISIBLE_TRIM_EDGES, '');
			}

			return str.replace(PARAMS.re.INVISIBLE_ALL, '');
		},
	}

	/**
	 * Функции для обработчиков событий
	 * То что мы используем на addEventListener
	 * @type type
	 */
	const funcForHandlers = {
		/**
		 * форматирование инпута + отслеживание курсора
		 * @param {type} event - событие. по нему получаем и элелемент и значение.
		 * @param {type} name - имя поле. ищем форматтер для него по Field_Schemas
		 * @returns значение инпута
		 */
		formatEvent(event, name, store) {
			const input = event.target;

			let formatter = null;

			if (store) {
				formatter = store?.getFieldRules(name)?.format;

				if (!formatter) {
					formatter = FIELD_SCHEMAS[name]?.format;
				}

			} else {
				formatter = FIELD_SCHEMAS[name]?.format;
			}

			if (!formatter || store?.getFieldRules(name)?.mask) {
				return input.value;
			}

			const oldValue = input.value;

			// форматируем значение
			const newValue = formatter(oldValue);

			// Значение не изменилось — не пишем в DOM и не переставляем курсор
			if (newValue === oldValue) {
				return input.value;
			}
			const cursorPos = input.selectionStart;

			input.value = newValue;

			// Считаем "полезные" символы до курсора (буквы/цифры)
			const charsBeforeCursor = oldValue.slice(0, cursorPos).replace(PARAMS.re.USEFUL_CHARS_REMOVE_G, '').length;

			// Находим позицию где столько же полезных символов
			let count = 0;
			let newCursor = 0;
			for (let i = 0; i < newValue.length && count < charsBeforeCursor; i++) {
				if (PARAMS.re.IS_USEFUL_CHAR.test(newValue[i])) {
					count++;
				}
				newCursor = i + 1;
			}

			// Восстанавливаем курсор
			requestAnimationFrame(() => {
				input.setSelectionRange(newCursor, newCursor);
			});
			return input.value;
		},

		/**
		 * Убираем пробел при потере фокуса
		 * @param {type} event
		 * @param {type} fieldName
		 * @param {type} store
		 * @returns {input.value|.event.target.value|String}
		 */
		blurFormat(e) {
			const input = e.target;

			input.value = String(input.value).trim();
			return input.value;
		},

		/**
		 * Очищаем дату при потере фокуса
		 * @param {type} e
		 * @returns {input.value|.e.target.value|String|.event.target.value}
		 */
		clearDataOnBlur(e) {
			const input = e.target || e;
			const val = input.value || '';

			let formattedVal = this.blurFormat(e);

			// Если дата неполная (меньше 10 символов или есть __) — очищаем
			if (val.length < 10 || /__/.test(val)) {
				input.value = '';
				return '';
			}

			// Если есть символы кроме цифр и точек — очищаем
			if (/[^0-9.]/.test(val)) {
				input.value = '';
				return '';
			}

			e.target.value = formattedVal;
			return formattedVal
		},

		/**
		 * Очистка вставляемого текста из буфера обмена.
		 * Использовать в обработчике paste.
		 *
		 * @param {Event} event - событие paste
		 * @param {'remove'|'trim'} [mode] - режим очистки
		 * @returns {string} новое значение input
		 */
		pasteClean(event, mode = 'remove') {
			const input = event.target;
			const clipboard = event.clipboardData || window.clipboardData;
			const raw = clipboard?.getData('text/plain') || clipboard?.getData('Text') || '';

			if (!raw) {
				return input.value;
			}

			event.preventDefault();

			const clean = eventsFuncsHelpers.cleanInvisible(raw, mode);

			const start = input.selectionStart ?? input.value.length;
			const end = input.selectionEnd ?? start;

			let value = input.value.slice(0, start) + clean + input.value.slice(end);

			const maxLength = Number(input.maxLength);

			if (Number.isFinite(maxLength) && maxLength >= 0) {
				value = value.slice(0, maxLength);
			}

			input.value = value;

			const caret = Math.min(start + clean.length, value.length);
			input.setSelectionRange(caret, caret);

			input.dispatchEvent(new Event('input', { bubbles: true }));

			return input.value;
		}


	}


	// ═══════════════════════════════════════════════════════════════════════════
	// PUBLIC API
	// ═══════════════════════════════════════════════════════════════════════════

	const publicAPI = {
		// форматирование значения
		format: (name, value = null, ctx) => {
			const func = FIELD_SCHEMAS[name]?.format || Formatter[name] || null;
			if (!func) {
				console.error("У поля нет форматтера!");
				return value ?? null;
			}
			if (value === null) {
				return func; // возвращаем функцию
			}
			return func(value, ctx); // возвращаем значение
		},

		// форматирование для бэка
		backendFormat: (name, value = null, ctx) => {
			const func = BackendFormatter[name];
			if (!func) {
				console.error("У поля нет backend форматтера!");
				return value ?? null;
			}
			if (value === null) {
				return func; // возвращаем функцию
			}
			return func(value, ctx); // возвращаем значение
		},

		// валидация значения
		validate: (name, value = null, ctx) => {
			const func = Validator[name] || FIELD_SCHEMAS[name]?.validate;
			if (!func) {
				console.error("У поля нет validate функции!");
				return ValidationResult.valid();
			}
			if (value === null) {
				return func; // возвращаем функцию
			}
			return func(value, ctx); // возвращаем значение
		},

		// маскировка полей значениями
		// obfuscate: (name, value = null) => {
		// 	const func = FIELD_SCHEMAS[name]?.obfuscate || null;
		// 	if (!func) {
		// 		console.error("У поля нет обфускатора!");
		// 		return value ?? null;
		// 	}
		// 	if (value === null) {
		// 		return func; // возвращаем функцию
		// 	}
		// 	return func(value); // возвращаем значение
		// },

		getAllSchemas: () => FIELD_SCHEMAS, // получить все схемы полей, для ссылки
		getSchema: (fieldName) => FIELD_SCHEMAS[fieldName] || {}, // получить схему конкретного поля

		// Операции с датами
		date: DateUtils,
		// Обработчики событий. ссылаемся на объект где используем конкретную функцию для события
		handlers: funcForHandlers,
	};

	return publicAPI;
})();
